// htmlToPdf.js
// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
    install(Vue, options) {
        Vue.prototype.getPdf2 = function (id, fileTitle = '') {
            return new Promise(async (resolve, reject) => {
                html2Canvas(document.querySelector(id), {
                    allowTaint: true,
                    taintTest: false,
                    useCORS: true,
                    y: 0, // 对Y轴进行裁切
                    x: 0,
                    width: 1200,
                    height: 1700,
                    dpi: window.devicePixelRatio * 1, //将分辨率提高到特定的DPI 提高四倍
                    scale: 1, //按比例增加分辨率
                }).then(function (canvas) {
                    let contentWidth = canvas.width
                    let contentHeight = canvas.height
                    let pageHeight = (contentWidth / 592.28) * 841.89
                    let leftHeight = contentHeight
                    let position = 0
                    let imgWidth = 595.28
                    let imgHeight = (560 / contentWidth) * contentHeight
                    let pageData = canvas.toDataURL('image/jpeg', 1.0)
                    //   console.log(pageData)

                    let PDF = new JsPDF('', 'pt', 'a4')
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'PNG', 0, 0, imgWidth, imgHeight)
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'PNG', 0, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    PDF.save(fileTitle + '.pdf')
                    resolve()
                })
            })
        }
    },
}
